import {Flex} from 'antd';
import React from 'react';

const NoTableData: React.FC<{icon?: React.ReactNode; title?: string}> = ({
  icon,
  title
}) => {
  return (
    <Flex
      vertical
      justify="center"
      align="center"
      gap={8}
      style={{minHeight: '150px'}}
    >
      {icon}
      <div>{title}</div>
    </Flex>
  );
};

export default NoTableData;
